export default __webpack_public_path__ + "static/media/CH.33d4ee2d.svg";